<template>
  <div class="content">
    <div v-for="item in noticeList"
         class="settingBox">
      <div class="titleIcon">
        <div class="icon"></div>
        <div class="title">{{ item.type }}</div>
      </div>
      <div class="select">
        <div class="title">{{ $t('Notice.NoticeSetting.receiveMethod') }}</div>
        <div class="rightBox">
          <a-button :type="item.primaryButton === false ? 'primary' : ''"
                    @click="handleClick(item, false)">{{ $t('Notice.NoticeSetting.siteMessage') }}</a-button>
          <a-button :type="item.primaryButton === true ? 'primary' : ''"
                    @click="handleClick(item, true)">{{ $t('Notice.NoticeSetting.sms') }}</a-button>
        </div>
      </div>
    </div>
    <!-- <a-table class="table"
             :dataSource="noticeList"
             :pagination="false"
             rowKey="id"
             :columns="tableColumns">
      <template #bodyCell="{ column }">
        <template v-if="column.key === 'siteType'">
          <a-checkbox v-model:checked="checked"></a-checkbox>
        </template>
<template v-if="column.key === 'phonemessage'">
          <a-checkbox v-model:checked="checked"></a-checkbox>
        </template>
</template>
</a-table> -->
  </div>
</template>


<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const handleClick = (item: typeof noticeList.value[0], value: boolean) => {
  item.primaryButton = value
  item = { ...item }
}

// declared static
const noticeList = computed(() => [
  { type: t('Notice.NoticeSetting.systemNotification'), siteType: 0, phonemessage: 0, primaryButton: false },
  { type: t('Notice.NoticeSetting.personalMessage'), siteType: 0, phonemessage: 0, primaryButton: false },
])

</script>


<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  padding: 24px;
  display: flex;

  .settingBox {
    background: url(../assets/ic-settingBg.png);
    background-size: contain;
    width: 25%;
    height: 150px;

    .titleIcon {
      display: inline-flex;
      align-items: center;
      padding: 30px;
      width: 100%;

      .icon {
        background: url(../assets/ic-personMessage.png);
        background-size: cover;
        width: 44px;
        height: 40px;
      }

      .title {
        font-size: 16px;
        font-family: 'Microsoft YaHei Bold';
        color: #111111;
        padding-left: 20px;
      }
    }
  }

  .settingBox:not(:first-child) {
    margin-left: 20px;
  }

  .select {
    display: inline-flex;
    align-items: center;
    width: 100%;

    .title {
      padding-left: 30px;
      font-size: 14px;
      color: #999999;
      flex: 0.8
    }

    .rightBox {
      display: inline-flex;
    }
  }
}
</style>
